export default __webpack_public_path__ + "static/media/MSWindows.6d6388e2.svg";